/**
 * CATMAN-S38 — Distingue el fallo de autoguardado causado por una sesión que ya no vale
 * del fallo que sí es del guardado.
 *
 * Cuando el token expira, el backend responde 401 y `TokenInterceptorService` hace dos cosas:
 * llama a `HttpCancelService.cancelPendingRequests()` y dispara el redirect a OIDC. Eso le deja al
 * autoguardado dos formas posibles de error, y ninguna es un problema del guardado:
 *
 * - el POST del autoguardado ES el que recibió el 401/403;
 * - el POST estaba en vuelo cuando *otra* request recibió el 401/403: el `takeUntil` de
 *   `HttpCancelInterceptor` lo completa sin emitir y el `first()` del pipe tira `EmptyError`.
 *
 * En los dos casos el editor no tiene nada que reportar: el interceptor ya se hace cargo (redirect
 * al login, o su propio modal de acceso denegado). Pintar "No se pudo guardar automáticamente"
 * encima sólo agrega ruido — y con un 403, un segundo modal tapando el del interceptor.
 */

/** Status HTTP donde la sesión o el acceso dejaron de valer y el interceptor toma el control. */
const SESSION_ENDED_STATUSES = [401, 403];

export function isSessionExpiredFailure(error?: any): boolean {
  if (error == null) return false;

  const status = Number(error?.status ?? error?.statusCode);
  if (SESSION_ENDED_STATUSES.includes(status)) return true;

  //`first()` sobre una fuente que completó sin emitir. La única forma de llegar acá es que
  //`cancelPendingRequests()` haya cortado la request en vuelo: HttpClient siempre emite una
  //respuesta o falla, y un corte de red da `status: 0`, no esto.
  return error?.name === 'EmptyError';
}
